import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import cost from "../../../assets/Flutter/Scalable-solution/Costeffective.svg";
import deploy from "../../../assets/Flutter/Scalable-solution/Deployment.svg";
import solution from "../../../assets/Flutter/Scalable-solution/Solution.svg";
import culture from "../../../assets/Flutter/Scalable-solution/working culture.svg";
import expert_flutter from "../../../assets/Flutter/Scalable-solution/Specialised_fluter_app.svg";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import CoreComponent14 from "../../../assets/Sub-component/CoreComponent14";
import { Link } from "react-router-dom";

import PHP_Customization from '../../../assets/Services/PHP_dev/PHP_Customization.svg'
import PHP_Portal from '../../../assets/Services/PHP_dev/PHP_Portal.svg'
import PHP_eCommerce_Development from '../../../assets/Services/PHP_dev/PHP_eCommerce_Development.svg'
import Plugin_Development from '../../../assets/Services/PHP_dev/Plugin_Development.svg'
import UI from '../../../assets/Services/PHP_dev/UI.svg'
import Web_Application_Development from '../../../assets/Services/PHP_dev/Web_Application_Development.svg'
import image from '../../../assets/Services/PHP_dev/image.png'
import FaqHome from "../../../components/faq/FaqHome";
import launchingimage from '../../../assets/Launchingimage.png'


const PhpDevelopment = () => {
  const content100 = [
    {
      icon: PHP_Customization,
      title: "PHP Customization",
      desc: "Raiden's technological expertise is customized to meet your specific needs, seamlessly integrates with your unique business process, and permits a high-profile brand launch without compromising quality. ",
    },
    {
      icon: Plugin_Development,
      title: "Plugin Development",
      desc: "We develop custom plugins with the appropriate functionality to add distinctive features to your website or app. The intelligence and efficiency of your system are enhanced without compromising the requirements.",
    },
    {
      icon: PHP_eCommerce_Development,
      title: "PHP eCommerce Development",
      desc: "We create user-friendly and secure online stores that are designed to convert browsing users into loyal customers, and you can handle everything from browsing to the checkout.",
    },

    {
      icon: UI,
      title: "PHP UX/UI Development",
      desc: "We believe that the first step to further development is a great design. We create sophisticated PHP UX/UI development that enables users to have an efficient and interesting experience with each click they make.",
    },
    {
      icon: PHP_Portal,
      title: "PHP Portal Development",
      desc: "We establish a focal point for all of your clients, suppliers, and staff, ensuring that interactions are productive. Creating a central space for all your customers, vendors, and employees and making the engagements productive. ",
    },
    {
      icon: Web_Application_Development,
      title: "Web Application Development",
      desc: "Our extensive web application experience, powered by PHP, creates robust and efficient solutions for your particular industry challenges, from automating intricate processes to handling enormous volumes of data. ",
    },
  ];

  const content = [
    {
      icon: expert_flutter,
      title: "Well-Acquainted",
      desc: "Our team works well with the entire PHP ecosystem, including the latest frameworks and critical third-party integrations. We understand your requirements and build optimized solutions for your business progress.",
      space: true,
    },
    {
      icon: cost,
      title: "Rational Experience",
      desc: "Raiden’s expertise provides a clear and logical solution for design, development, and evidently lowering the risk in your every project with our expertise.",
      space: true,
    },

    {
      icon: culture,
      title: "Specialization",
      desc: "Our skilled PHP web developers provide websites with PHP customization, e-commerce, and other plugin features and integrate UI/UX design for a complete experience.",
      space: false,
    },
    {
      icon: deploy,
      title: "Accessibility",
      desc: "Our open reporting and project management techniques guarantee that you can easily contact our team and are always informed. This creates a genuine partnership and eases the stress of the development process.",
      space: false,
    },
    {
      icon: solution,
      title: "Timeframe",
      desc: "Our project management technique guarantees that we will adhere to the timeline and finish the project within the allocated budget, with excellent quality, allowing you to launch your business effectively.",
      space: false,
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
  className="Bg-image"
  alt="Launching"
/>

    <div className="main-page-wrapper overflow-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" container height-vh topheader-margin  d-flex justify-content-center flex-column align-items-center"
        
      >
        <h1 className="h1-heading lh-sm fw-bold text-center">
          PHP Web Development
        </h1>
        {/* <p className="fw-semibold mt-2 h1-para lh-base text-center ">
          {" "}
          code | dot | sjf | dsfs
        </p> */}
        <p className="text-center mt-4 mb-4 h1-para lh-base">
          Raiden is the most effective
          Mobile App Development company,
          offering a wide range of cutting-edge technologies with superior
          solutions. We prioritize the latest PHP versions and provide scalable
          architecture, attentive monitoring, and efficient PHP solutions to
          meet your business's needs.
        </p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6 h2-heading lh-sm   mb-3 mb-lg-0">
              PHP Development Services
            </h2>
            <p className="col-lg-6 h1-para lh-base" >
             Raiden creates authentic digital experiences that improve the business perspective. We are aware that you need a solution that not only streamlines your business operations and fosters growth but also genuinely understands and serves your customers. We make it possible.
            </p>
          </div>

          <div >
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={image} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm">
              Experience the Raiden Difference in PHP
            </h2>
            <p className="mt-4  h1-para lh-base">
              Raiden serves you with efficient PHP development services with
              more than ten years in the industry. Our team of 50+ experts has
              worked with clients across over 40 countries. That's more than
              just experience; it's a global viewpoint that produces tangible
              outcomes.
            </p>
            <p className="mt-2  h1-para lh-base" >
              Choosing Raiden for your PHP development entails acquiring a
              strategic partner dedicated to your expansion. We take care of the
              technical responsibilities so you can concentrate on your top
              business priorities. Focus on your growth; Raiden keeps your app
              running at its best.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <h2 className="mb-4 text-center h2-heading lh-sm ">
          The Raiden Difference: Modern PHP for Business Growth
        </h2>
        <p className="mb-40 text-center px-4 h1-para lh-base" >
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore iusto
          quisquam aspernatur aliquam nostrum accusamus placeat dicta odio
          blanditiis, tenetur ut aut rerum adipisci explicabo officia cumque
          facilis culpa impedit!
        </p>

        <CoreComponent14 content={content} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart ">
        <h2 className="h2-heading lh-sm">
          Mastering the Full Spectrum of PHP Excellence{" "}
        </h2>
        <p className="mt-4 mb-4 pb-2 h1-para lh-base">
          Excellence and Successful Execution
        </p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default PhpDevelopment;
